import { Controller } from "remult";

@Controller("partner-organization-address-methods")
export class PartnerOrganizationAddressMethods {}
